// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wiDZ","newExpiryDate":"styles_newExpiryDate__QjRsr","footer":"styles_footer__1jflC"};